import {
  Button as DesignSystemButton,
  type ButtonProps as DesignSystemButtonProps,
  type ButtonVariant,
} from "../../design-system";

export type ButtonTone = "primary" | "secondary" | "quiet" | "danger";

const VARIANT_BY_TONE: Record<ButtonTone, ButtonVariant> = {
  primary: "primary",
  secondary: "secondary",
  quiet: "ghost",
  danger: "danger",
};

export interface ButtonProps extends Omit<DesignSystemButtonProps, "variant"> {
  tone?: ButtonTone;
}

export function Button({ tone = "secondary", ...props }: ButtonProps) {
  return <DesignSystemButton {...props} variant={VARIANT_BY_TONE[tone]} />;
}
